var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapAssetFauna = function SvgFiremapAssetFauna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 4h16v16H4zM2 22V2h20v20zm8.96-11.737V8.804H6v6.392h1.897v-2.198h2.844V11.54H7.897v-1.277zm4.642 3.912.374 1.02H18l-2.635-6.39h-1.951l-2.727 6.39h1.952l.383-1.02zm-.502-1.386h-1.55l.784-2.088z",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapAssetFauna;